export default __webpack_public_path__ + "static/salesforce-9a587f5e83cdcc84d780bb6f6823a46f.png";